import type { RouteObject } from "react-router-dom";

export const developerToolsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Developer Tools" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { DeveloperToolsPage } = await import("./developer-tools-page");
          return { Component: DeveloperToolsPage };
        },
      },
    ],
  },
];
